import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

function DealersAndReps() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          <Link to="/about-us">About Us</Link>
          <Link className="active" to="/dealers">Dealers &amp; Representatives</Link>
          <Link to="/sustainability">Sustainability</Link>
          <Link to="/refurbished">Refurbished Balers</Link>
        </aside>
        <article className="article">
          <span className="eyebrow">Company</span>
          <h2>Dealers &amp; Representatives</h2>
          <div className="content-stack">
            <section className="content-block">
              <div className="selection-media-row">
                <div className="selection-media-copy">
                  <div className="body-copy">There is likely a <strong>C&amp;M Baling Systems</strong> dealer or <strong>OEM representative</strong> near you. If there is not, we will gladly prepare information for you at our home office.</div>
                  <div className="body-copy">Contact C&amp;M if you would like to be informed about a C&amp;M representative near your location.</div>
                  <div className="body-copy">Are you an experienced <strong>recycling machinery</strong> or <strong>material handling equipment dealer</strong> and interested in representing a great line of balers and baling presses?</div>
                  <div className="body-copy"><Link to="/contact/general-inquiry">Contact us if you are interested.</Link></div>
                </div>
                <img className="service-side-image" src="/img/thumbnails/DealerAndRepsPic1.jpg" alt="C&M baler installation represented by dealer network" />
              </div>
            </section>
            <section className="content-block">
              <div className="selection-media-row reverse">
                <div className="selection-media-copy">
                  <div className="body-copy"><strong>C&amp;M representatives</strong> help customers review applications, discuss <strong>material handling</strong> needs, and prepare information for selecting the right baling press or handling system.</div>
                  <div className="body-copy">Useful information includes material type, volume, <strong>loading method</strong>, available space, <strong>power requirements</strong>, bale size, and downstream handling expectations.</div>
                </div>
                <img className="service-side-image" src="/img/thumbnails/DealerAndRepsLeftColumnPic1.jpg" alt="C&M dealer support equipment installation" />
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/general-inquiry">Contact C&amp;M <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default DealersAndReps;
